import { ElectronApi } from '@/services/electron.api';
import { GlobalConfig } from '@/services/gloabl.config';
import { random } from 'lodash-es';
import generateID from './generate-id';
import { textToMd5 } from './md5.utils';
/**
 * 生成表盘随机id，等同于pkgName
 * @returns
 */
export const getWatchfaceRandomId = () => {
  return random(100000000, 199999999).toString();
};
/**
 * 生成表盘id，等同于pkgName
 * @returns
 */
export const getWatchfaceDefaultId = () => {
  return GlobalConfig.defaultWatchfaceId;
};

/**
 * 返回表盘私有id，需要确保唯一性
 * @returns
 */
export const getWatchfacePrivateId = (deviceType: string) => {
  let macStr = '';
  try {
    macStr = JSON.stringify(ElectronApi.os?.networkInterfaces() ?? {});
  } catch (error) {
    macStr = generateID();
  }
  return textToMd5(
    [macStr, deviceType, generateID(), getWatchfaceRandomId(), Date.now()].join(
      '-'
    )
  );
};
